import { render, staticRenderFns } from "./EditTemplate.vue?vue&type=template&id=081fc6fa&scoped=true&"
import script from "./EditTemplate.vue?vue&type=script&lang=js&"
export * from "./EditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fc6fa",
  null
  
)

export default component.exports